import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import { CaretLeft, Phone } from '@phosphor-icons/react';
import {
  ORGANIC_CHAT_STEPS,
  ORGANIC_CHAT_STEP_LABELS,
  type OrganicChatStep,
} from 'components/Experiments/OrganicChat/config/steps';
import { CallRailPhone, CallRailComponentType } from 'components';
import { Events } from 'services';
import { PageRoutes } from 'constants/pageRoutes';
import { Container } from './Container';
import { PageContent } from '../PageContent';

const NavBar = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

const labelStyles = ({ theme }) => `
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${theme.customTheme.colors.headerText};
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
`;

const BackButton = styled.button`
  ${labelStyles}
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  -webkit-appearance: none;
  appearance: none;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    opacity: 0.8;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.customTheme.colors.headerText};
    outline-offset: 4px;
    border-radius: 2px;
  }
`;

const StepLabel = styled.span`
  ${labelStyles}
`;

const MobileCallContainer = styled.div`
  display: block;

  ${({ theme }) => theme.mediaQueries.m} {
    display: none;
  }
`;

const DesktopCallContainer = styled.div`
  display: none;

  ${({ theme }) => theme.mediaQueries.m} {
    display: flex;
    justify-content: center;
    padding: 7px 8px;
    flex-direction: column;
    align-items: center;
  }
`;

export const LumisHeader = () => {
  const router = useRouter();
  const slugArr = router.query.slug as string[] | undefined;
  const currentSlug = slugArr?.[0] ?? '';
  const currentIndex = ORGANIC_CHAT_STEPS.indexOf(
    currentSlug as OrganicChatStep
  );
  // Mirror resolveStep: unknown/empty slug → first step
  const effectiveIndex = currentIndex >= 0 ? currentIndex : 0;
  const effectiveStep = ORGANIC_CHAT_STEPS[effectiveIndex];

  const prevStep =
    effectiveIndex > 0 ? ORGANIC_CHAT_STEPS[effectiveIndex - 1] : null;
  const currentLabel = ORGANIC_CHAT_STEP_LABELS[effectiveStep];

  const handleBack = () => {
    router.push(`${PageRoutes.offerWizard}/${prevStep}`);
  };

  return (
    <Container>
      <PageContent>
        <NavBar>
          {prevStep ? (
            <BackButton onClick={handleBack}>
              <CaretLeft size={20} aria-hidden="true" />
              {currentLabel}
            </BackButton>
          ) : (
            <StepLabel>{currentLabel}</StepLabel>
          )}
          <DesktopCallContainer>
            <CallRailPhone
              variant="xl"
              text="###"
              clickEventName={Events.CALL_BUTTON_DESKTOP_HEADER}
              textColor="#fff"
              icon={<Phone />}
            />
          </DesktopCallContainer>
          <MobileCallContainer>
            <CallRailPhone
              buttonSize="s"
              componentType={CallRailComponentType.BUTTON}
              text="Call now!"
              icon={<Phone weight="fill" />}
              clickEventName={Events.CALL_BUTTON_MOBILE_HEADER}
            />
          </MobileCallContainer>
        </NavBar>
      </PageContent>
    </Container>
  );
};
